import { typeWriter } from "./typing-effect.js";
import { countryCodes } from "./country_codes.js";
import { showToast, showGlobalPreloader, hideGlobalPreloader } from "./utils.js";

document.addEventListener("DOMContentLoaded", () => {
  const requestOtpForm = document.getElementById("request-otp-form");
  const verifyOtpForm = document.getElementById("verify-otp-form");
  const resetPasswordForm = document.getElementById("reset-password-form");
  const identifierTypeDropdown = document.getElementById(
    "identifier-type-dropdown",
  );
  const identifierInput = document.getElementById("identifier");
  const phoneInputContainer = document.getElementById("phone-input-container");
  const phoneInput = document.getElementById("phone");
  const phoneNumberError = document.getElementById("phone-number-error");
  const otpInput = document.getElementById("otp-input");
  const resendOtpBtn = document.getElementById("resend-otp-btn");
  const newPasswordInput = document.getElementById("new-password");
  const confirmPasswordInput = document.getElementById("confirm-password");

  let globalIdentifier = "";
  let globalIdentifierType = "username"; // Default
  let globalCountryCode = "+91"; // Default

  // --- Utility Functions ---

  function validatePhoneNumber() {
    const currentPhone = phoneInput.value.trim();
    phoneNumberError.textContent = ""; // Clear previous errors

    const phoneRegex = /^\d*$/; // Only allow digits
    if (!phoneRegex.test(currentPhone)) {
      phoneNumberError.textContent = "Phone number must contain only digits.";
      phoneInput.setCustomValidity("Phone number must contain only digits.");
    } else {
      phoneInput.setCustomValidity("");
    }
  }

  // --- Country Code Dropdown Population ---
  const countryCodeDropdownOptions = document.querySelector(
    "#phoneInputContainer #countryCodeDropdown .dropdown-options",
  );
  const selectedCountryCodeSpan = document.querySelector(
    "#phoneInputContainer #selectedCountryCode",
  );
  const hiddenCountryCodeInput = document.querySelector(
    "#phoneInputContainer #countryCode",
  );

  if (countryCodeDropdownOptions && typeof countryCodes !== "undefined") {
    countryCodes.forEach((country) => {
      const a = document.createElement("a");
      a.href = "#";
      a.setAttribute("data-value", country.code);
      a.textContent = `${country.code} (${country.name})`;
      countryCodeDropdownOptions.appendChild(a);
    });

    // Set initial selected value (e.g., India +91)
    const defaultCountry = countryCodes.find(
      (country) => country.code === "+91",
    );
    if (defaultCountry) {
      selectedCountryCodeSpan.textContent = `${defaultCountry.code} (${defaultCountry.name})`;
      hiddenCountryCodeInput.value = defaultCountry.code;
      globalCountryCode = defaultCountry.code;
    }
  }

  // --- Event Listeners ---
  if (phoneInput) {
    phoneInput.addEventListener("input", validatePhoneNumber);
  }

  const countryCodeDropdown = document.getElementById("countryCodeDropdown");
  if (countryCodeDropdown) {
    countryCodeDropdown.addEventListener("dropdown-change", (e) => {
      globalCountryCode = e.detail.value;
      if (globalIdentifierType === "phone") {
        validatePhoneNumber();
      }
    });
  }

  identifierTypeDropdown.addEventListener("dropdown-change", (e) => {
    globalIdentifierType = e.detail.value;
    if (globalIdentifierType === "phone") {
      phoneInputContainer.style.display = "flex";
      identifierInput.style.display = "none";
      identifierInput.required = false;
      phoneInput.required = true;
      identifierInput.value = ""; // Clear email/username input
      phoneNumberError.textContent = ""; // Clear phone error
    } else {
      // Covers 'username' and 'email'
      phoneInputContainer.style.display = "none";
      identifierInput.style.display = "block";
      identifierInput.required = true;
      phoneInput.required = false;
      identifierInput.placeholder = `Enter your ${globalIdentifierType}`;
      phoneInput.value = ""; // Clear phone input
      phoneNumberError.textContent = ""; // Clear phone error
    }
  });

  // --- Step 1: Request OTP Form Submission ---
  if (requestOtpForm) {
    requestOtpForm.addEventListener("submit", async (event) => {
      event.preventDefault();

      if (globalIdentifierType === "phone") {
        validatePhoneNumber();
        if (phoneInput.checkValidity() === false) {
          showToast(phoneNumberError.textContent, "error");
          return;
        }
        globalIdentifier = globalCountryCode + phoneInput.value;
      } else if (globalIdentifierType === "username") {
        globalIdentifier = identifierInput.value;
      } else {
        globalIdentifier = identifierInput.value;
      }

      // Basic validation
      if (!globalIdentifier) {
        showToast("Please enter your identifier.", "error");
        return;
      }

      showGlobalPreloader("Sending OTP...");

      try {
        const response = await fetch("/api/auth/forgot-password/request-otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            identifier: globalIdentifier,
            identifier_type: globalIdentifierType,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          showToast(data.message, "success");
          requestOtpForm.style.display = "none";
          verifyOtpForm.style.display = "block";
        } else {
          showToast(data.error || "Failed to send OTP.", "error");
        }
      } catch {
        showToast("Network error. Please try again.", "error");
      } finally {
        hideGlobalPreloader();
      }
    });
  }

  // --- Step 2: Verify OTP Form Submission ---
  if (verifyOtpForm) {
    verifyOtpForm.addEventListener("submit", async (event) => {
      event.preventDefault();

      const otp = otpInput.value;
      if (!otp || otp.length !== 4) {
        showToast("Please enter a 4-digit OTP.", "error");
        return;
      }

      showGlobalPreloader("Verifying OTP...");

      try {
        const response = await fetch("/api/auth/forgot-password/verify-otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            identifier: globalIdentifier,
            identifier_type: globalIdentifierType,
            otp: otp,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          showToast(data.message, "success");
          verifyOtpForm.style.display = "none";
          resetPasswordForm.style.display = "block";
        } else {
          showToast(data.error || "OTP verification failed.", "error");
        }
      } catch {
        showToast("Network error. Please try again.", "error");
      } finally {
        hideGlobalPreloader();
      }
    });
  }

  // --- Resend OTP Button ---
  if (resendOtpBtn) {
    resendOtpBtn.addEventListener("click", async () => {
      showGlobalPreloader("Resending OTP...");
      try {
        const response = await fetch("/api/auth/forgot-password/request-otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            identifier: globalIdentifier,
            identifier_type: globalIdentifierType,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          showToast(data.message, "success");
        } else {
          showToast(data.error || "Failed to resend OTP.", "error");
        }
      } catch {
        showToast("Network error. Please try again.", "error");
      } finally {
        hideGlobalPreloader();
      }
    });
  }

  // --- Step 3: Reset Password Form Submission ---
  if (resetPasswordForm) {
    resetPasswordForm.addEventListener("submit", async (event) => {
      event.preventDefault();

      const newPassword = newPasswordInput.value;
      const confirmPassword = confirmPasswordInput.value;

      if (newPassword !== confirmPassword) {
        showToast("Passwords do not match.", "error");
        return;
      }
      if (newPassword.length < 6) {
        // Basic password length check
        showToast("Password must be at least 6 characters long.", "error");
        return;
      }

      showGlobalPreloader("Resetting Password...");

      try {
        const response = await fetch("/api/auth/forgot-password/reset", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            identifier: globalIdentifier,
            identifier_type: globalIdentifierType,
            new_password: newPassword,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          showToast(data.message, "success");
          setTimeout(() => {
            window.location.href = "/login"; // Redirect to login page
          }, 2000);
        } else {
          showToast(data.error || "Failed to reset password.", "error");
        }
      } catch {
        showToast("Network error. Please try again.", "error");
      } finally {
        hideGlobalPreloader();
      }
    });
  }

  // Initialize typing effect
  const typingHeading = document.getElementById("typing-heading");
  if (typingHeading) {
    typeWriter(typingHeading, "Reset Your Password");
  }
});
